import { BkRoutes } from 'bkng';

import { template } from './template/template';

export const emails: BkRoutes = [
    {
        path: "template",
        label: "Organization Emails Template",
        children: template,
    },
];
